import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Checkbox, Popover } from 'antd';
import { isEmpty } from './utils';
import UIValue from './uiValue';
import UIValidation from './uiValidation';
import UIText from './uiText';
import { InfoCircleOutlined } from '@ant-design/icons';
function UICheckboxComponent(props) {
    const [value, setValue] = useState(props.checkedValues || []);
    const options = props.options.map((o) => {
        return { label: o, value: o };
    });
    useEffect(() => {
        if (props.checkedValues && props.checkedValues.length > 0) {
            setValue(props.checkedValues);
            return;
        }
        if (props.defaultTrue && options.length > 0) {
            setValue([options[0].value]);
        }
    }, [props.checkedValues, props.defaultTrue, props.options]);
    const handleChange = (checkedValues) => {
        setValue(checkedValues);
        props.onChange(checkedValues);
    };
    return (_jsxs("div", { style: { display: 'flex', alignItems: 'center', ...props.styling }, children: [props.title && (_jsxs("label", { style: { marginRight: '16px', whiteSpace: 'nowrap', width: '120px', textAlign: 'left' }, children: [props.title, ' ', props.text && (_jsx(Popover, { content: props.text, trigger: "click", overlayStyle: { width: 300, height: 120 }, children: _jsx(InfoCircleOutlined, { style: { cursor: 'pointer' } }) }))] })), _jsx(Checkbox.Group, { options: options, onChange: handleChange, value: value })] }));
}
export default class UICheckbox extends UIValue {
    title;
    text;
    options;
    onChange;
    style;
    defaultTrue;
    constructor(s) {
        super(s);
        this.title = this.getProperty('title');
        if ('text' in s) {
            this.text = new UIText(s);
        }
        this.options = [];
        this.value = [];
        this.style = this.getProperty('style', '');
        this.defaultTrue = this.getProperty('defaultTrue', false);
        if ('options' in s && s.options) {
            for (const o of s.options) {
                if (!isEmpty(o)) {
                    this.options.push(o);
                }
            }
        }
        if (this.defaultTrue && this.options.length > 0) {
            this.value = [this.options[0]];
        }
    }
    getComponent() {
        const text = this.text !== undefined ? this.text.getComponent() : null;
        const onChange = (checkedValues) => {
            this.value = checkedValues;
            this.error = undefined;
        };
        return (_jsx(UIValidation, { error: this.error, children: _jsx(UICheckboxComponent, { title: this.title, text: text, options: this.options, onChange: onChange, checkedValues: this.value, styling: this.style, defaultTrue: this.defaultTrue }) }));
    }
}
//# sourceMappingURL=uiCheckbox.js.map